var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReInviteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Re-invite_18px",
    transform: "translate(-1166 -476)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_813",
    "data-name": "Rectangle 813",
    width: 18,
    height: 18,
    transform: "translate(1166 476)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2493",
    "data-name": "Group 2493",
    transform: "translate(61.226 -148.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail-open-outline",
    transform: "translate(1105.625 626.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M63.418,86.312l-6.845-3.378a.962.962,0,0,0-.852,0l-6.845,3.378a1.567,1.567,0,0,0-.877,1.4v7.232a1.577,1.577,0,0,0,1.587,1.567H62.71A1.577,1.577,0,0,0,64.3,94.945V87.714A1.567,1.567,0,0,0,63.418,86.312Z",
    transform: "translate(-48 -82.835)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M73.387,194.2l-4.738,3.3a.963.963,0,0,1-1.08,0l-4.739-3.3m7.332,2.393-4-.066",
    transform: "translate(-59.96 -187.377)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "add-outline",
    d: "M113.823,112v3.646m1.823-1.823H112",
    transform: "translate(999.951 518.004)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReInviteIcon);
export default __webpack_public_path__ + "static/media/re-invite-icon.fd0ba6f0671388ff200354c382a3ab76.svg";
export { ForwardRef as ReactComponent };